import { priceChartType } from "../type";

const initialState = {
  lotCode: undefined, //[]
  customerCode: undefined,
  lotCodeObj: undefined, //{}
  pricingChartDetails: undefined, //{}
  tempPricingChartRow: undefined,
  isShowRow: false,
  isShowRowCopy: false,
  error: undefined,
  isLoading: false,
  lotCodeSummary: undefined,
  message: undefined,
  Currency: undefined,
  MCP: undefined,
  SalesPrice: undefined,
  lotCodeId: undefined,
  lotCodeOpt: [],
  internal: [],
  MMSize: [],
  SieveSize: [],
  Commodity: [],
  shape: [],
  color: [],
  filterObject: undefined, //{}
  activeRmName: undefined,
};

const pricingChartReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;
  const {
    data,
    totalCount,
    priceChartId,
    componentId,
    message,
    status,
    lotCodeOpt,
    lotCodeSummary,
    Currency,
    rmNames,
    CustomerCode,
    LotCode,
    MCP,
    SalesPrice,
    lotCodeId,
    internal,
    MMSize,
    SieveSize,
    Commodity,
    shape,
    color,
  } = payload;
  switch (type) {
    case priceChartType.PRICING_CHART_STATUS:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          component: state.pricingChartDetails.map((state) =>
            state._id === componentId
              ? { ...state, isLock: status }
              : { ...state }
          ),
        },
      };
    case priceChartType.PRICING_CHART_UPDATE:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          ComponentDetails: {
            ...state.pricingChartDetails.ComponentDetails,
            [rmNames]: {
              ...state.pricingChartDetails.ComponentDetails[rmNames],
              data: state.pricingChartDetails.ComponentDetails[
                rmNames
              ].data.map((state) =>
                state._id === componentId ? { ...state, ...payload } : state
              ),
            },
          },
        },
      };
    case priceChartType.PRICING_CHART_INSERT:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeSummary,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          ComponentDetails: {
            ...state.pricingChartDetails.ComponentDetails,
            [rmNames]: {
              pagination: {
                ...state.pricingChartDetails.ComponentDetails[rmNames]
                  .pagination,
                totalcount:
                  state.pricingChartDetails.ComponentDetails[rmNames].pagination
                    .totalcount + data.length,
              },
              data: [
                ...data,
                ...state.pricingChartDetails.ComponentDetails[rmNames].data,
              ],
            },
          },
        },
      };
    case priceChartType.PRIICNG_CHART_SINGLE_INSERT:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        tempPricingChartRow: undefined,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          ComponentDetails: {
            ...state.pricingChartDetails.ComponentDetails,
            [rmNames]: {
              pagination: {
                ...state.pricingChartDetails.ComponentDetails[rmNames]
                  .pagination,
                totalcount:
                  state.pricingChartDetails.ComponentDetails[rmNames].pagination
                    .totalcount + 1,
              },
              data: [
                data,
                ...state.pricingChartDetails.ComponentDetails[rmNames].data,
              ],
            },
          },
        },
      };
    case priceChartType.PRIICNG_CHART_COPY:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        tempPricingChartRow: payload,
      };
    case priceChartType.PRIICNG_CHART_COPY_LOT_CODE_REMOVE:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        tempPricingChartRow: {
          ...state.tempPricingChartRow,
          LotCode: "",
          lotCode: "",
        },
      };

    case priceChartType.PRIICNG_CHART_BULK_REMOVE:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeSummary: undefined,
      };
    case priceChartType.GET_PRICE_CHART:
      // console.log("data----",data)
      return {
        ...state,
        isLoading: false,
        Currency,
        message: payload,
        error: undefined,
        pricingChartDetails: data,
        customerCode:CustomerCode,
      };
    case priceChartType.PRIICNG_CHART_DELETE:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          ComponentDetails: {
            ...state.pricingChartDetails.ComponentDetails,
            [rmNames]: {
              pagination: {
                ...state.pricingChartDetails.ComponentDetails[rmNames]
                  .pagination,
                totalcount:
                  state.pricingChartDetails.ComponentDetails[rmNames].pagination
                    .totalcount - 1,
              },
              data: state.pricingChartDetails.ComponentDetails[
                rmNames
              ].data.filter((state) => state._id !== componentId),
            },
          },
        },
      };
    case priceChartType.PRICE_CHART_LOTCODE:
      return {
        ...state,
        lotCodeObj: data,
        isLoading: false,
        message,
        error: undefined,
      };

    // case priceChartType.SAVE_CUSTOMER_CODE:
    //   // console.log("customerCode===", customerCode);
    //   return {
    //     ...state,
    //     customerCode,
    //     isLoading: false,
    //     message,
    //     error: undefined,
    //   };
    case priceChartType.PRICE_CHART_LOTCODE_LIST:
      return {
        ...state,
        isLoading: false,
        message,
        lotCode: data,
        lotCodeOpt: lotCodeOpt,
        error: undefined,
      };
    case priceChartType.PRICING_CHART_MESSAGE:
      return { ...state, isLoading: false, message: payload, error: undefined };
    case priceChartType.ERROR_PRICE_CHART:
      return { ...state, error: payload };
    case priceChartType.PRIICNG_CHART_PAGINATION:
      return {
        ...state,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          ComponentDetails: {
            ...state.pricingChartDetails.ComponentDetails,
            [rmNames]: data,
          },
        },
        isLoading: false,
        message: payload,
        error: undefined,
      };
    case priceChartType.PRIICNG_SUGGESSION_DATA:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        internal,
        SieveSize,
        MMSize,
        Commodity,
        shape,
        color,
      };
    case priceChartType.PRIICNG_CHART_BULK_UPDATE_EXCEL:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        pricingChartDetails: {
          ...state.pricingChartDetails,
          ComponentDetails: {
            ...state.pricingChartDetails.ComponentDetails,
            [rmNames]: {
              ...state.pricingChartDetails.ComponentDetails[rmNames],
              data: [...payload.updatedData],
            },
          },
        },
      };

    case priceChartType.PRIICNG_CHART_SET_FILTER:
      return {};

    case priceChartType.PRIICNG_CHART_RM_SET:
      return {
        ...state,
        activeRmName: payload,
      };

    case priceChartType.PRIICNG_CHART_TOGGLE_FILTER:
      return {
        ...state,
        isShowRow: payload,
      };

    case priceChartType.TOGGLE_COPY_ROW:
      return {
        ...state,
        isShowRowCopy: payload,
      };

    case priceChartType.LOADING_PRICEING_CHART:
      return {
        ...state,
        isLoading: payload,
      };

    case priceChartType.PRICEING_CHART_TOTAL_COUNT:
      return {
        ...state,
        totalCount: totalCount - 1,
      };

    default:
      return state;
  }
};

export default pricingChartReducer;
